import { useEffect, useRef } from "react";
import { useLocation } from "react-router-dom";
import Lenis from "lenis";

const EXCLUDED_PREFIXES = ["/admin", "/marketing", "/sales", "/promoter", "/ai-assistant"];

const SmoothScroll = () => {
  const { pathname } = useLocation();
  const lenisRef = useRef(null);
  const excluded = EXCLUDED_PREFIXES.some((p) => pathname.startsWith(p));

  useEffect(() => {
    if (excluded) return;
    const lenis = new Lenis({
      lerp: 0.09,
      smoothWheel: true,
      prevent: (node) =>
        !!node.closest('[role="dialog"], [data-radix-popper-content-wrapper], [data-lenis-prevent]'),
    });
    lenisRef.current = lenis;
    let rafId;
    const raf = (time) => {
      lenis.raf(time);
      rafId = requestAnimationFrame(raf);
    };
    rafId = requestAnimationFrame(raf);
    return () => {
      cancelAnimationFrame(rafId);
      lenis.destroy();
      lenisRef.current = null;
    };
  }, [excluded]);

  useEffect(() => {
    if (lenisRef.current) lenisRef.current.scrollTo(0, { immediate: true });
  }, [pathname]);

  return null;
};

export default SmoothScroll;
